const array = {
  // 数组去重
  cancel: (arr, key = 'id') => {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        const arrItem1 = arr[i] instanceof Object ? arr[i][key] : arr[i];
        const arrItem2 = arr[j] instanceof Object ? arr[j][key] : arr[j];
        if (arrItem1 === arrItem2) {
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  },
  // 数组排序
  sort: (arr, key = 'id') => {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        const arrItem1 = arr[i] instanceof Object ? Number(arr[i][key]) : Number(arr[i]);
        const arrItem2 = arr[j] instanceof Object ? Number(arr[j][key]) : Number(arr[j]);
        if (arrItem1 > arrItem2) {
          let temp = arr[i];
          arr[i] = arr[j];
          arr[j] = temp;
        }
      }
    }
    return arr;
  }
}

export default array;